import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftNavClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.1543 2.40391C13.7394 2.48422 15 3.7949 15 5.4V10.6002L14.9961 10.7545C14.9183 12.2885 13.6883 13.5186 12.1543 13.5963L12 13.6002H4L3.8457 13.5963C2.31172 13.5186 1.08172 12.2884 1.00391 10.7545L1 10.6002V5.4C1 3.74315 2.34315 2.4 4 2.4H12L12.1543 2.40391ZM4 3.4C2.89543 3.4 2 4.29543 2 5.4V10.6002C2.00011 11.7047 2.8955 12.6002 4 12.6002H12C13.1045 12.6002 13.9999 11.7047 14 10.6002V5.4C14 4.29543 13.1046 3.4 12 3.4H4ZM4.59961 5.32188C4.87564 5.32188 5.09942 5.54589 5.09961 5.82188V10.1773C5.09961 10.4535 4.87575 10.6773 4.59961 10.6773C4.32365 10.6771 4.09961 10.4534 4.09961 10.1773V5.82188C4.09979 5.54602 4.32376 5.32209 4.59961 5.32188Z",
		fill: "currentColor"
	})
});
export default SvgLeftNavClosed;
